import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { CryptoService } from './crypto.service';
import { TokenResponse } from '../models/token-response';
import { Observable, lastValueFrom, throwError, catchError, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import jwt_decode, { JwtPayload } from 'jwt-decode';
import { SessionService } from './session.service';
import { Error } from "../models/basic-response";
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private http: HttpClient,
    public storageService: StorageService,
    private httpService: HttpClient,
    private cryptoService: CryptoService,
    private sessionService: SessionService
  ) { }

  async login(username: string, password: string): Promise<TokenResponse> {
    let apiUrl = environment.apiUrl + "/api/connect/login";
    let body = {
      Username: this.cryptoService.encrypt(username),
      Password: this.cryptoService.encrypt(password),
      secured: true
    };

    try {
      const response = await lastValueFrom(
        this.httpService.post<TokenResponse>(apiUrl, body).pipe(
          catchError((error: HttpErrorResponse) => {
            // TODO: Checar por que solo recibe un string en vez del error response object
            // Manejo del error aquí
            if (error.status === 401) {
              const errorResponse = new TokenResponse(false);
              errorResponse.errors = [new Error(401, "Credenciales incorrectas.")];
              return of(errorResponse); // Retorna un observable con el error
            }

            // console.error('HTTP Error:', error);
            const unexpectedError = new TokenResponse(false);
            unexpectedError.errors = [new Error(error.status, 'Credenciales incorrectas')];
            return of(unexpectedError); // Retorna un observable con el error inesperado
          })
        )
      );
      // const response = await lastValueFrom(post);
      return response;
    }
    catch (error) {
      console.error('Login error:', error);

      throw error; // Handle or rethrow as needed
    }
  }


  refreshAuthenticationToken(): Observable<TokenResponse> {
    let apiUrl = environment.apiUrl + "/api/connect/refresh";
    let body = {
      refreshToken: this.storageService.refreshToken
    };
    return this.http.post<TokenResponse>(apiUrl, body);
  }

  async checkAndRefreshToken(): Promise<boolean> {
    if (!this.storageService.token) return false;
    if (this.isTokenExpired()) {
      try {
        const response = await lastValueFrom(this.refreshAuthenticationToken());
        if (response?.access_token && response?.refresh_token) {
          // this.sessionService.saveTokens(response.access_token, response.refresh_token);
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.error('Failed to refresh token', error);
        return false;
      }
    } else {
      return true;
    }
  }

  getTokenExpiration(): number | null {
    const token = this.storageService.token;
    if (token) {
      const decodedToken = jwt_decode<JwtPayload>(token);
      return decodedToken.exp ? decodedToken.exp * 1000 : null; // Convert to milliseconds
    }
    return null;
  }

  isTokenExpired(): boolean {
    const expiration = this.getTokenExpiration();
    return expiration ? Date.now() > expiration : true;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    return throwError(() => { return 'Could not authenticate.' });
  }
}
